import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "d-flex align-items-center" }
const _hoisted_2 = ["value"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["data-bs-content"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info align-middle" }, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.useStatusFeature)
      ? _withDirectives((_openBlock(), _createElementBlock("select", {
          key: 0,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedStatus) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleStatusChange && _ctx.handleStatusChange(...args))),
          class: _normalizeClass(['form-select form-select-sm shadow-none fs-13 text-black', _ctx.selectClass]),
          style: {"width":"130px"}
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (option) => {
            return (_openBlock(), _createElementBlock("option", {
              key: option,
              value: option
            }, _toDisplayString(option), 9, _hoisted_2))
          }), 128))
        ], 34)), [
          [_vModelSelect, _ctx.selectedStatus]
        ])
      : (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn btn-outline-primary btn-sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.generatePassEmail())),
            style: {"--bs-btn-padding-y":".25rem","--bs-btn-padding-x":".5rem","--bs-btn-font-size":".75rem"}
          }, _toDisplayString(_ctx.showInfoIcon ? 'Regenerate Pass Email' : 'Click to Draft Pass Email'), 1)
        ])),
    (_ctx.showInfoIcon)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (_ctx.statusReason)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "popover-content clickable ms-2",
                tabindex: "0",
                "data-bs-toggle": "popover",
                "data-bs-trigger": "hover focus",
                "data-bs-content": `Previously passed due to: ${_ctx.statusReason}`
              }, _hoisted_6, 8, _hoisted_4))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}